export default "__VITE_ASSET__CFsTISk$__"